import React from 'react';
import { connect } from 'react-redux';
import {BarChart, Bar, XAxis, YAxis, Legend, LabelList, ResponsiveContainer} from 'recharts';

const formName = 'auctionSummaryReportSalesRepFilter';

const STATES = {
  sold: { name: 'SOLD', fill: '#49A949'},
  not_sold: { name: 'NOT SOLD', fill: '#E2750F'},
  pulled: { name: 'PULLED', fill: '#F0DC28'},
};

const SalesRepBarChart = ({data, filterValues}) => {
  let filteredData = data;
  if (filterValues.sales_reps.length) {
    filteredData = data.filter(datum => filterValues.sales_reps.includes(datum.name));
  }
  if (filteredData.length === 1) return null
  let states = ['sold', 'not_sold', 'pulled'];
  if (filterValues.sales_states.length) {
    states = filterValues.sales_states;
  }
  const totals = { sold: 0, not_sold: 0, pulled: 0};
  data.forEach(datum => {
    totals.sold += datum.sold;
    totals.not_sold += datum.not_sold;
    totals.pulled += datum.pulled;
  });
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={filteredData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis axisLine={false} tickLine={false} dataKey="name" />
        <YAxis axisLine={false} tickLine={false} />
        <Legend
          verticalAlign="top"
          align="right"
          iconType="circle"
          wrapperStyle={{fontSize: '10px', fontWeight: 500, paddingBottom: "25px"}}
        />
        {states.map((saleState, saleStateI) => (
          <Bar key={saleStateI} dataKey={saleState} name={`${STATES[saleState].name  } (${totals[saleState]})`} fill={STATES[saleState].fill} stackId="a">
            <LabelList
              style={{fontSize:10}}
              valueAccessor={(accessorValue) => accessorValue[saleState] || ''}
            />
            {saleStateI === states.length - 1 &&
              <LabelList
                style={{fontSize:10}}
                position="top"
                valueAccessor={(accessorValue) => accessorValue.sold + accessorValue.not_sold + accessorValue.pulled || ''}
              />
            }
          </Bar>
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

const mapStateToProps = state => ({
  filterValues: (state.form[formName] && state.form[formName].values) ? state.form[formName].values : {},
});

export default connect(mapStateToProps, null)(SalesRepBarChart);
